import { useRouter } from "next/router";
import { CHECK_TOKEN_TIMEOUT, REFRESH_TOKEN } from "@/apollo/queries/user";
import routes from "@/lib/routes";
import { useApolloClient } from "@apollo/client/react";
export function useCheckTokenTimeout() {
  const router = useRouter();
  const client = useApolloClient();
  const checkTokenTimeoutAndRedirectOnError = async () => {
    const { data } = await client.query({
      query: CHECK_TOKEN_TIMEOUT,
      fetchPolicy: "network-only",
    });
    if (data) {
      if (data?.checkTokenTimeout?.result === false) {
        await client.mutate({
          mutation: REFRESH_TOKEN,
          fetchPolicy: "network-only",
        });
        await router.push(routes.timeOut);
      }
    }
    return data;
  };
  return { checkTokenTimeoutAndRedirectOnError };
}
